import React from 'react';
import SvgIconDPC from '../dpc-svg-icon';

export default class DpcCardHorizontal extends React.Component {


    render(){
        return (
            <div className="row">
                {this.props.image && this.props.slug &&
                    <div className="col-12 col-xl-6">
                        <a href={this.props.slug}>
                            <img src={this.props.image?.relationships?.image?.localFile?.publicURL} className="img-fluid w-100 my-3" alt={this.props.image?.field_alt}/>
                        </a>                    
                    </div>
                }
                {this.props.image && !this.props.slug &&
                    <div className="col-12 col-xl-6">                       
                        <img src={this.props.image?.relationships?.image?.localFile?.publicURL} className="img-fluid w-100 my-3" alt={this.props.image?.field_alt}/>
                    </div>
                }
                {
                    this.props.streaming &&
                        <div className="col-12 col-xl-6">
                            <div className="embed-responsive embed-responsive-16by9">
                                <iframe className="embed-responsive-item" allowFullScreen="" title={this.props.title}
                                    src={this.props.streaming?.field_link?.uri} />
                            </div>
                        </div>
                }
                <div className="col-12 col-xl-6">
                    <h2>{this.props.slug && this.props.slugText ? <a href={this.props.slug}>{this.props.title}</a> : this.props.title}</h2>
                    <div className="my-3" dangerouslySetInnerHTML={{__html: this.props.testoIntero? this.props.body: getText(this.props.body)}}/>
                    {(this.props.slug && this.props.slugText) &&
                        <a className="read-more my-3" href={this.props.slug}>
                            <span className="text">{this.props.slugText}</span>
                            <SvgIconDPC name={'arrow-right'}/>
                        </a>
                    }
                </div>
            </div>
        )
    }

}

export const getText = (text) =>{
    if(!text || typeof text !== "string")
        return "";

    const regex = /(( ?)<\/?(?:a)[^>]*>)|<[^>]+>( ?)/ig;
    const subst = `$1`;
    const body = text.replace(regex, subst);

    if(body.length <= 350)
        return body;
    const subString = body.substr(0, 349);
    return subString.substr(0, subString.lastIndexOf(" ")) + "...";
}
